import { AppBar, Button, Card, CardActionArea, CardActions, CardContent, Dialog, Grid, IconButton, InputAdornment, TextField, Toolbar, Typography } from '@mui/material';
import React, { Component } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { WorkoutRepository } from './WorkoutRepository';
import { SecondsToHoursAndMinutes } from '../utils/Time';
import { Workout } from './Workout';
import WorkoutOverview from './WorkoutOverview';

interface WorkoutSelectorDialogProps {
    open: boolean;
    handleClose: (succes: boolean, workout: Workout | null) => void;
    workoutSelected: (workout: Workout) => void;
}

class WorkoutSelectorDialog extends Component<WorkoutSelectorDialogProps> {
    render() {
        return (
            <Dialog open={this.props.open} fullScreen>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton className='button' edge="start" color="inherit" onClick={() => this.onClose(false)}>
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Workout Catalog
                        </Typography>
                    </Toolbar>
                </AppBar>

                <div style={{margin: "1rem"}}>
                    <div style={{marginBottom: '1rem'}}>Select a workout</div>
                    <Grid container spacing={2}>
                        {WorkoutRepository.AllWorkouts.map(
                            (workout, index) => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                    <Card>
                                        <CardActionArea onClick={() => this.selectWorkout(workout)}>
                                            <CardContent>
                                                <Typography variant="h5" component="div">
                                                    {workout.Name}
                                                </Typography>
                                                <WorkoutOverview workout={workout} />
                                                <div>{SecondsToHoursAndMinutes(workout.Intervals.map(i => i.TotalSeconds).reduce((sum, i) => sum + i))}</div>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small">Details</Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))
                        }
                    </Grid>
                </div>
            </Dialog>
        );
    }

    selectWorkout(workout: Workout) {
        this.onClose(true);
        this.props.workoutSelected(workout);
    }

    onClose(success: boolean) {
        if (this.props.handleClose) {
            this.props.handleClose(success, null);
        }
    }
}

export default WorkoutSelectorDialog;